// @flow
import React from "react";

import styles from "./searchFormTabs.module.scss";
import BasicButton from "../BasicButton";
import Typography from "../Typography";

type Props = {
  active: "hourly" | "monthly",
  onChange: (value: "hourly" | "monthly") => void
};

const cypress = "search-form-tabs";

const SearchFormTabs = ({ active, onChange }: Props) => {
  const isHourly = active === "hourly";

  return (
    <div className={styles.base} data-cy={cypress}>
      <BasicButton
        onClick={() => {
          onChange("hourly");
        }}
      >
        <Typography bold={isHourly} color={isHourly ? "brand" : "primary"}>
          <div className={isHourly ? styles.activeTab : styles.tab}>
            Hourly / Daily
          </div>
        </Typography>
      </BasicButton>
      <BasicButton
        onClick={() => {
          onChange("monthly");
        }}
      >
        <Typography bold={!isHourly} color={!isHourly ? "brand" : "primary"}>
          <div className={!isHourly ? styles.activeTab : styles.tab}>
            Monthly
          </div>
        </Typography>
      </BasicButton>
    </div>
  );
};

export default SearchFormTabs;
